import React from "react";
import { render } from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import cookie from "react-cookies";
import { Provider } from "react-redux";

import "./index.css";
import "./style/normalize.css";
import { setAPIAuthorizationToken } from "./apis/API";
import "./i18n/i18n";
import { initAdTrack } from "./utils/attribution";
import { initTracking } from "./apis/FacebookAPI";
import { getLocation } from "./utils/getLocation";
import { store } from "./store";

// 谷歌,facebook,站点配置初始化
initAdTrack();

Promise.allSettled([initTracking(), getLocation(store.dispatch)]).then(
  (results) => {
    results.forEach((result) => {
      if (result.status === "rejected") {
        console.error("Application initialization failed:", result.reason);
      }
    });
  },
);

/**
 * ✅ 渲染
 */
render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root"),
);

reportWebVitals();
